module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('ul', [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'contractlist'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Nettmeny")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'catering'
      },
      "exact": ""
    }
  }, [_c('a', [_vm._v("Catering")])])], 1)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n          " + _vm._s(_vm.thisYear) + " © Helt Opplagt på Jobben.\n          "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Bruker- og salgsbetingelser.")]), _vm._v(" "), _c('span', {
    staticClass: "app__version pull-right"
  }, [_vm._v("v" + _vm._s(this.version))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/HeltOpplagtLogo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('strong', [_vm._v("Support 0800 - 1600")])])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-phone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:02346"
    }
  }, [_vm._v("0 23 46")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "mailto:post@heltopplagt.no"
    }
  }, [_vm._v("post@heltopplagt.no")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/Heltopplagt",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-facebook-official",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://plus.google.com/+HeltopplagtNofruktlunsjogrenluft/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-google-plus-square",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23e329c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/footer.vue
// module id = 883
// module chunks = 16